'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'bulldozer';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e655';
var svgPathData = ['M80 400c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-224 0c-35.3 0-64 28.7-64 64zm32-160l0 52.6c10.1-3 20.9-4.6 32-4.6l224 0c11.1 0 21.9 1.6 32 4.6l0-36.6c0-8.8-7.2-16-16-16l-272 0zm72 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M200.4 32c24.2 0 46.4 13.7 57.2 35.4l62.3 124.6 32 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 74c27.6 7.1 48 32.2 48 62l0 40 80 0 0-80c0-48.6 39.4-88 88-88 13.3 0 24 10.7 24 24s-10.7 24-24 24c-22.1 0-40 17.9-40 40l0 208c0 22.1 17.9 40 40 40 13.3 0 24 10.7 24 24s-10.7 24-24 24c-48.6 0-88-39.4-88-88l0-80-63 0c9.5 16.5 15 35.6 15 56 0 61.9-50.1 112-112 112l-224 0c-61.9 0-112-50.1-112-112 0-30.5 12.2-58.2 32-78.4L64 96c0-35.3 28.7-64 64-64l72.4 0zM112 292.6c10.1-3 20.9-4.6 32-4.6l224 0c11.1 0 21.9 1.6 32 4.6l0-36.6c0-8.8-7.2-16-16-16l-272 0 0 52.6zM214.8 88.8c-2.7-5.4-8.3-8.8-14.3-8.8L128 80c-8.8 0-16 7.2-16 16l0 96 154.3 0-51.6-103.2zM144 336c-35.3 0-64 28.7-64 64s28.7 64 64 64l224 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-224 0zm184 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM136 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBulldozer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;